<template>
  <div class="trending-topics">
    <h3 class="typo-headline-6">Temas Populares</h3>
    <ul v-if="trendingTopics.length">
      <trending-topic
        v-for="topic in trendingTopics"
        :key="topic.id"
        :topic="topic"
      />
    </ul>
    <p v-else class="typo-body-2">Cargando temas populares...</p>
  </div>
</template>

<script>
import forumApi from '@/services/forumApi';
import TrendingTopic from './TrendingTopic.vue';

export default {
  name: 'TrendingTopicsContainer',
  components: {
    TrendingTopic
  },
  data() {
    return {
      trendingTopics: [],
      loading: true,
      error: null
    };
  },
  mounted() {
    this.fetchTrendingTopics();
  },
  methods: {
    fetchTrendingTopics() {
      forumApi
        .get('/forum/api/popular-posts?limit=5')
        .then(response => {
          this.trendingTopics = response.data;
        })
        .catch(err => {
          console.error('Error fetching trending topics:', err);
          this.error = 'Error al cargar temas populares';
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.trending-topics {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 15px;
  color: var(--color-text-primary);
}

.trending-topics h3 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

/* List Reset */
ul {
  padding: 0;
  margin: 0;
}
</style> 